import React from "react";
import { Button, Flex, Typography, Badge, theme, Switch } from "antd";
import { BellOutlined, ArrowLeftOutlined, MoonOutlined, BulbOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { storageName } from "@/constans/auth";
import { useThemeContext } from "../../../context/ThemeContext";
import CompanySwitch from "../../company/components/CompanySwitch";
import { useHybridResponsive } from "../hooks";

const {  Title } = Typography;


interface HeaderAppProps {
  sectionName: string;
  showNotifications?: boolean;
  showBack?: boolean;
  backPath?: string;
  showUserData?: boolean;
  extraButtons?: React.ReactNode;
}

const HeaderApp: React.FC<HeaderAppProps> = ({
  sectionName,
  showNotifications = false,
  showBack = false,
  backPath = null,
  extraButtons,
}) => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const { isDarkMode, toggleTheme } = useThemeContext();
  const { isMobile } = useHybridResponsive();


  const userData = localStorage.getItem(storageName);
  let user: User | null = null;
  if (userData) {
    try {
      user = JSON.parse(userData);
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
    }
  }

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        height: 64,
        padding: "0 16px",
        background: token.colorBgContainer,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        boxShadow: token.boxShadowTertiary,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Flex align="center" justify="space-between" style={{ width: "100%" }}>
        {/* ── Left: Back + Avatar + Title ── */}
        <Flex align="center" gap={10}>
          {showBack && (
            <Button
              type="text"
              shape="circle"
              icon={
                <ArrowLeftOutlined
                  style={{ fontSize: 18, color: token.colorText }}
                />
              }
              onClick={handleBack}
              style={{ flexShrink: 0 }}
            />
          )}

          <Flex vertical gap={0} justify="center">
          
            <Title
              style={{
                margin: 0,
                fontWeight: 800,
                fontSize:  18,
                color: token.colorText,
                lineHeight: 1.3,
              }}
            >
              {sectionName}
            </Title>
          </Flex>
        </Flex>


        {/* ── Right: Notifications + Extra Buttons ── */}
        <Flex align="center" gap={12}>
          {!isMobile && <section style={{ width: "245px" }}>
            <CompanySwitch />
          </section>}
          <Switch
            checked={isDarkMode}
            onChange={toggleTheme}
            checkedChildren={<MoonOutlined />}
            unCheckedChildren={<BulbOutlined />}
            style={{ marginRight: 8 }}
          />
          {showNotifications && (
            <Badge count={3} size="small" offset={[-4, 4]}>
              <Button
                type="text"
                shape="circle"
                icon={
                  <BellOutlined
                    style={{ fontSize: 20, color: token.colorText }}
                  />
                }
              />
            </Badge>
          )}
          {extraButtons && <section>{extraButtons}</section>}
        </Flex>
      </Flex>
    </header>
  );
};

export default HeaderApp;
